import React from "react";
import { Globe, Smartphone, Laptop, Video, Lightbulb } from "lucide-react";

export const APP_TYPES = [
  { id: "web", label: "Web app", icon: Globe, placeholder: "Build me an e-commerce platform with…" },
  { id: "mobile", label: "Mobile app", icon: Smartphone, placeholder: "A mobile app to track my gym workouts with…" },
  { id: "website", label: "Website", icon: Laptop, placeholder: "A website for my interior design studio with…" },
  { id: "video", label: "Video", icon: Video, placeholder: "An animated promo video for my coffee brand showing…" },
  { id: "idea", label: "Brainstorm", icon: Lightbulb, placeholder: "I have a rough idea for an app that…" },
];

export const AppTypeChips = ({ value, onChange, testid = "app-type" }) => (
  <div className="w-full overflow-x-auto scrollbar-hide" data-testid={`${testid}-chips`}>
  <div className="w-max mx-auto flex items-center gap-2 sm:gap-2.5 px-1 py-1" role="radiogroup">
    {APP_TYPES.map(({ id, label, icon: Icon }) => {
      const on = value === id;
      return (
        <button key={id} type="button" role="radio" aria-checked={on} aria-label={label} title={label} onClick={() => onChange(id)}
          data-testid={`${testid}-${id}`}
          className={`shrink-0 h-11 rounded-full flex items-center justify-center gap-2 transition-[background-color,box-shadow,padding] duration-300 ${on
            ? "px-4 sm:px-5 bg-white text-slate-900 font-medium shadow-[0_4px_14px_-4px_rgba(15,23,42,0.18)] ring-1 ring-slate-200"
            : "w-12 sm:w-14 bg-white/45 text-slate-600 hover:bg-white/70 backdrop-blur-md ring-1 ring-white/60"}`}>
          <Icon size={18} strokeWidth={1.8} />
          {on && <span className="text-[15px] whitespace-nowrap">{label}</span>}
        </button>
      );
    })}
  </div>
  </div>
);

export default AppTypeChips;
